<template>
  <div>

    <div>
      <h3 class="title-color">Review and Sign</h3>
    </div>

    <fieldset>
      <legend><h3>Applicant</h3></legend>
      <div class="grid-container">
        <div class="data-label">Requestor:</div>
        <div>
          {{ permit.requestor }}
        </div>

        <div class="data-label">Application Date:</div>
        <div>
          {{ applicationDate }}
        </div>

        <div class="data-label">PO/Reference #:</div>
        <div>
          {{ permit.planReviewNo }}
        </div>

        <div class="data-label" ref="permitApplicantInReview">Permit Applicant:</div>
        <div>
          {{ permitApplicant }}
        </div>

        <div class="data-label">Applicant Company:</div>
        <div>
          {{ permit.applicantCompany.legalName }}
        </div>

        <div class="data-label">Applicant Company Address:</div>
        <div>
          {{ permit.applicantCompany.address }}
        </div>

        <div class="data-label">City/Town:</div>
        <div>
          {{ permit.applicantCompany.cityName }}
        </div>

        <div class="data-label">Province:</div>
        <div>
          {{ permit.applicantCompany.provinceName }}
        </div>

        <div class="data-label">Postal Code/Zip:</div>
        <div>
          {{ permit.applicantCompany.postalCode }}
        </div>

        <div class="data-label">Country:</div>
        <div>
          {{ permit.applicantCompany.countryName }}
        </div>

        <div class="data-label">Municipality:</div>
        <div>
          {{ municipality }}
        </div>

        <div class="data-label">Permit #:</div>
        <div>
          {{ permit.permitNo }}
        </div>

        <div class="data-label" ref="applicantName">Applicant Name:</div>
        <div>
          {{ getName(permit.applicantContact) }}
        </div>

        <div class="data-label" ref="applicantEmail">Applicant Email:</div>
        <div>
          {{ permit.applicantContact.email }}
        </div>

        <div class="data-label" ref="applicantPhone">Applicant Phone:</div>
        <div>
          {{ permit.applicantContact.phone }}
        </div>

        <div class="data-label" ref="applicantAltPhone">
          Applicant Alt Phone:
        </div>
        <div>
          {{ permit.applicantContact.altPhone }}
        </div>

        <div class="data-label">Development Permit Number:</div>
        <div>
          {{ permit.developmentPermitNumber }}
        </div>

        <div class="data-label">Other Permits Required:</div>
        <div>
          {{ otherPermitsRequired }}
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend><h3>Site Owner</h3></legend>
      <div class="grid-container">
        <div class="data-label">Owner Number:</div>
        <div>
          {{ permit.ePermitSite.ownerID }}
        </div>

        <div class="data-label">Owner Company:</div>
        <div>
          {{ permit.ePermitSite.ownerCompany.legalName }}
        </div>

        <div class="data-label">Owner Company Address:</div>
        <div>
          {{ permit.ePermitSite.ownerCompany.address }}
        </div>

        <div class="data-label">City/Town:</div>
        <div>
          {{ permit.ePermitSite.ownerCompany.cityName }}
        </div>

        <div class="data-label">Province:</div>
        <div>
          {{ permit.ePermitSite.ownerCompany.provinceName }}
        </div>

        <div class="data-label">postal Code/Zip:</div>
        <div>
          {{ permit.ePermitSite.ownerCompany.postalCode }}
        </div>

        <!-- <div class="data-label">Municipality:</div>
        <div>{{ municipality }}</div> -->

        <div class="data-label">Owner Name:</div>
        <div>
          {{ getName(permit.ePermitSite.ownerContact) }}
        </div>

        <div class="data-label" ref="ownerEmail">Owner Email:</div>
        <div>
          {{ permit.ePermitSite.ownerContact.email }}
        </div>

        <div class="data-label" ref="ownerPhone">Owner Phone:</div>
        <div>
          {{ permit.ePermitSite.ownerContact.phone }}
        </div>

        <div class="data-label" ref="ownerAltPhone">Owner Alt Phone:</div>
        <div>
          {{ permit.ePermitSite.ownerContact.altPhone }}
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend><h3>Contractor</h3></legend>
      <div class="grid-container">
        <div class="data-label">Contractor Company:</div>
        <div>
          {{ permit.contractorCompany.legalName }}
        </div>

        <div class="data-label">Contractor Company Address:</div>
        <div>
          {{ permit.contractorCompany.address }}
        </div>

        <div class="data-label">City/Town:</div>
        <div>
          {{ permit.contractorCompany.cityName }}
        </div>

        <div class="data-label">Province:</div>
        <div>
          {{ permit.contractorCompany.provinceName }}
        </div>

        <div class="data-label">postal Code/Zip:</div>
        <div>
          {{ permit.contractorCompany.postalCode }}
        </div>

        <div class="data-label">Contractor Name:</div>
        <div>
          {{ getName(permit.contractorContact) }}
        </div>

        <div class="data-label" ref="contractorEmail">Contractor Email:</div>
        <div>
          {{ permit.contractorContact.email }}
        </div>

        <div class="data-label" ref="contractorPhone">Contractor Phone:</div>
        <div>
          {{ permit.contractorContact.phone }}
        </div>

        <div class="data-label" ref="contractorAltPhone">
          Contractor Alt Phone:
        </div>
        <div>
          {{ permit.contractorContact.altPhone }}
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend><h3>Project Location</h3></legend>
      <div class="grid-container">
        <div class="data-label">Site Number:</div>
        <div>
          {{ permit.ePermitSite.siteId }}
        </div>

        <div class="data-label">Site Name:</div>
        <div>
          {{ permit.ePermitSite.siteName }}
        </div>

        <div class="data-label">Site Address:</div>
        <div>
          {{ permit.ePermitSite.siteAddress.address }}
        </div>

        <div class="data-label">City/Town:</div>
        <div>
          {{ permit.ePermitSite.siteAddress.cityName }}
        </div>

        <div class="data-label">Province:</div>
        <div>
          {{ permit.ePermitSite.siteAddress.provinceName }}
        </div>

        <div class="data-label">postal Code/Zip:</div>
        <div>
          {{ permit.ePermitSite.siteAddress.postalCode }}
        </div>

        <div class="data-label">Municipality:</div>
        <div>
          {{ municipality }}
        </div>

        <div class="data-label">Lot:</div>
        <div>
          {{ permit.ePermitSite.lot }}
        </div>

        <div class="data-label">Block:</div>
        <div>
          {{ permit.ePermitSite.block }}
        </div>

        <div class="data-label">Plan:</div>
        <div>
          {{ permit.ePermitSite.plan }}
        </div>

        <div class="data-label">Legal Subdivision:</div>
        <div>
          {{ permit.ePermitSite.atS_LSD }}
        </div>
        <div class="data-label">Quarter:</div>
        <div>
          {{ permit.ePermitSite.atS_QuarterType }}
        </div>

        <div class="data-label">Section:</div>
        <div>
          {{ permit.ePermitSite.atS_Section }}
        </div>

        <div class="data-label">Township:</div>
        <div>
          {{ permit.ePermitSite.township }}
        </div>

        <div class="data-label">Range:</div>
        <div>
          {{ permit.ePermitSite.range }}
        </div>

        <div class="data-label">Meridian:</div>
        <div>
          {{ permit.ePermitSite.meridian }}
        </div>

        <div class="data-label">Company Ref ID:</div>
        <div>
          {{ permit.ePermitSite.companyRef }}
        </div>

        <div class="data-label" ref="estStartDate">
          Estimated Commencement Date:
        </div>
        <div>
          {{ estStartDate }}
        </div>

        <div class="data-label" ref="estEndDate">
          Estimated Completion Date:
        </div>
        <div>
          {{ estEndDate }}
        </div>

        <div class="data-label">Directions:</div>
        <div>
          {{ permit.ePermitSite.directions }}
        </div>

        <div class="data-label" ref="workDesc">Description of Work:</div>
        <div>
          {{ permit.workDesc }}
        </div>

        <div class="data-label">Value of Installation:</div>
        <div>
          {{
            new Intl.NumberFormat(`en-US`, {
                currency: `USD`,
                style: 'currency',
            }).format(permit.valueOfInstallation)
             }}
        </div>

        <div class="data-label">Status:</div>
        <div>
          {{ permitStatus }}
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend><h3>Installer Details</h3></legend>
      <div class="grid-container">
        <div class="data-label">Installer Company Name:</div>
        <div>
          {{ permit.installerCompany.legalName }}
        </div>

        <div class="data-label">Installer Company Address:</div>
        <div>
          {{ permit.installerCompany.address }}
        </div>

        <div class="data-label">Installer Company City/Town:</div>
        <div>
          {{ permit.installerCompany.cityName }}
        </div>

        <div class="data-label">Installer Company Province:</div>
        <div>
          {{ permit.installerCompany.provinceName }}
        </div>

        <div class="data-label">Installer Company postal Code/Zip:</div>
        <div>
          {{ permit.installerCompany.postalCode }}
        </div>

        <div class="data-label">CPCA ID:</div>
        <div>
          {{ permit.installerContact.cpcaId }}
        </div>

        <div class="data-label">TSSA ID:</div>
        <div>
          {{ permit.installerContact.tssaId }}
        </div>

        <div class="data-label">PTMAA ID:</div>
        <div>
          {{ permit.installerContact.ptmaaId }}
        </div>

        <div class="data-label">Installer Name:</div>
        <div>
          {{ getName(permit.installerContact) }}
        </div>

        <div class="data-label" ref="installerEmail">Installer Email:</div>
        <div>
          {{ permit.installerContact.email }}
        </div>

        <div class="data-label" ref="installerPhone">Installer Phone:</div>
        <div>
          {{ permit.installerContact.phone }}
        </div>

        <div class="data-label" ref="installerAltPhone">
          Installer Alt Phone:
        </div>
        <div>
          {{ permit.installerContact.altPhone }}
        </div>

        <div ref="installerComments" class="data-label">{{ commentsLabel }}</div>
        <div>
          {{ permit.installerContact.comments }}
        </div>

        <div class="data-label">Engineer Company Name:</div>
        <div>
          {{ permit.engineerCompany.legalName }}
        </div>

        <div class="data-label">Engineer Company Address:</div>
        <div>
          {{ permit.engineerCompany.address }}
        </div>

        <div class="data-label">Engineer Company City/Town:</div>
        <div>
          {{ permit.engineerCompany.cityName }}
        </div>

        <div class="data-label">Engineer Company Province:</div>
        <div>
          {{ permit.engineerCompany.provinceName }}
        </div>

        <div class="data-label">Engineer Company postal Code/Zip:</div>
        <div>
          {{ permit.engineerCompany.postalCode }}
        </div>

        <div class="data-label">Reg No:</div>
        <div>
          {{ permit.engineerContact.regNo }}
        </div>

        <div class="data-label">Engineer Name:</div>
        <div>
          {{ getName(permit.engineerContact) }}
        </div>

        <div class="data-label" ref="engineerEmail">Engineer Email:</div>
        <div>
          {{ permit.engineerContact.email }}
        </div>

        <div class="data-label" ref="engineerPhone">Engineer Phone:</div>
        <div>
          {{ permit.engineerContact.phone }}
        </div>

        <div class="data-label" ref="engineerAltPhone">Engineer Alt Phone:</div>
        <div>
          {{ permit.engineerContact.altPhone }}
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend><h3>Installation Details</h3></legend>
      <div class="grid-container-installer-details">
        <div
          style="display: flex; width: 80%; justify-content: space-between"
          v-for="(applicationWorkList, index) in applicationWorkLists"
          :key="index"
        >
          <div class="data-label" style="width: 40%">
            {{ applicationWorkList.question }}
          </div>
          <div style="width: 10%">
            {{ applicationWorkList.answerValue }}
          </div>
          <div style="width: 40%">
            {{ applicationWorkList.answerAdditionalInformation }}
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend><h3>FOIP Disclosure</h3></legend>
      <div>
        <b v-html="staticMessage"></b>
      </div>
      <ejs-checkbox
        label="I have read and agree to this statement"
        :checked="permit.foip"
        :disabled="true"
      />
    </fieldset>

    <fieldset>
      <legend><h3>Facility/Tank</h3></legend>
      <div class="grid-container">
        <div class="data-label" ref="facilityTypeLabel">Facility Type:</div>
        <div>
          {{ facilityType }}
        </div>

        <div
          v-if="showFacilityTypeDesc"
          class="data-label"
          ref="facilityTypeDescLabel"
        >
          Facility Type Description:
        </div>
        <div v-if="showFacilityTypeDesc">
          {{ permit.ePermitSite.facilityTypeOther }}
        </div>

        <div class="data-label" ref="permitTypeLabel">Permit Type:</div>
        <div>
          {{ permitType }}
        </div>

        <div class="data-label" ref="supplierCompanyLabel">
          {{ supplierRemovalCompanyLabel }}:
        </div>
        <div>
          {{ permit.ePermitSite.oilRemovalCompanyDesc }}
        </div>
      </div>

      <div v-for="(tank, index) in permit.ePermitSite.eSiteTanks" :key="index">
        <fieldset>
          <legend>
            <h5>Tank No. {{ index + 1 }}</h5>
          </legend>
          <div class="grid-container" :ref="tank.ascaTankNumber">
            <div class="data-label" :ref="`tankType${tank.ascaTankNumber}`">Tank Type:</div>
            <div>
              {{ tank.tankType }}
            </div>

            <div
              v-if="tank.isInstallationTank"
              class="data-label"
              :ref="`forASTsOnly${tank.ascaTankNumber}`"
            >
              For AST's Only:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.forASTsOnly }}
            </div>

            <div
              class="data-label"
              :ref="`singleDoubleWall${tank.ascaTankNumber}`"
              v-if="tank.forASTsOnly && tank.isInstallationTank"
            >
              {{ forASTSingleDoubleTilte(tank.forASTsOnly) }}:
            </div>
            <div v-if="tank.forASTsOnly && tank.isInstallationTank">
              {{ forASTSingleDoubleValue(tank) }}
            </div>

            <div class="data-label" :ref="`ulcAPI${tank.ascaTankNumber}`">
              ULC/API Value:
            </div>
            <div>
              {{ tank.constructionType }}
            </div>

            <div
              class="data-label"
              :ref="`ulcApiDesc${tank.ascaTankNumber}`"
              v-if="showDesc(tank.constructionType)"
            >
              ULC/API Description:
            </div>
            <div v-if="showDesc(tank.constructionType)">
              {{ tank.constructionDesc }}
            </div>

            <div class="data-label" v-if="tank.isInstallationTank">
              ASCA Tank Number:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.ascaTankNumber }}
            </div>

            <div
              class="data-label"
              v-if="tank.isInstallationTank"
              :ref="`custTankNo${tank.ascaTankNumber}`"
            >
              Customer Tank Number:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.custTankNumber }}
            </div>

            <div
              class="data-label"
              v-if="tank.isInstallationTank"
              :ref="`tankSerialNo${tank.ascaTankNumber}`"
            >
              Tank Serial Number:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.serialNo }}
            </div>

            <div class="data-label" :ref="`tankCapacity${tank.ascaTankNumber}`">
              Tank Capacity:
            </div>
            <div>
              {{ tank.capacity }}
            </div>

            <div class="data-label" :ref="`contentsType${tank.ascaTankNumber}`">
              Type of Product Stored:
            </div>
            <div>
              {{ tank.contentsType }}
            </div>

            <div
              class="data-label"
              v-if="tank.isInstallationTank"
              :ref="`tankLeakDetection${tank.ascaTankNumber}`"
            >
              Tank Leak Detection:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.tankLeakDetection }}
            </div>

            <div
              :ref="`tankLeakDetectionDesc${tank.ascaTankNumber}`"
              class="data-label"
              v-if="
                showDesc(tank.tankLeakDetection) &&
                tank.isInstallationTank
              "
            >
              Tank Leak Description:
            </div>
            <div
              v-if="
                showDesc(tank.tankLeakDetection) &&
                tank.isInstallationTank
              "
            >
              {{ tank.tankLeakDetectionDescription }}
            </div>

            <div
              class="data-label"
              :ref="`spill${tank.ascaTankNumber}`"
              v-if="tank.isInstallationTank"
            >
              Spill Containment System:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.spillContainmentSystem }}
            </div>

            <div
              class="data-label"
              :ref="`overfill${tank.ascaTankNumber}`"
              v-if="tank.isInstallationTank"
            >
              Overfill Protection:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.overfillProtection }}
            </div>

            <div
              class="data-label"
              :ref="`overfillDesc${tank.ascaTankNumber}`"
              v-if="showDesc(tank.overfillProtection) && tank.isInstallationTank"
            >
              Overfill Protection Description:
            </div>
            <div v-if="showDesc(tank.overfillProtection) && tank.isInstallationTank">
              {{ tank.overfillProtectionDescription }}
            </div>

            <div
              class="data-label"
              :ref="`sumps${tank.ascaTankNumber}`"
              v-if="tank.isInstallationTank"
            >
              Sumps:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.sump }}
            </div>

            <div
              class="data-label"
              v-if="tank.isInstallationTank"
              :ref="`splitType${tank.ascaTankNumber}`"
            >
              Split Tank:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.splitType }}
            </div>

            <div class="data-label" v-if="tank.isInstallationTank">
              Vent Piping:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ getVentPiping(tank) }}
            </div>

            <div class="data-label" v-if="tank.isInstallationTank">Piping:</div>
            <div v-if="tank.isInstallationTank">
              {{ getPiping(tank) }}
            </div>

            <div class="data-label" v-if="tank.isInstallationTank">
              Piping Containment:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.pipingContainment }}
            </div>

            <div class="data-label" v-if="tank.isInstallationTank">
              Piping Material Type:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.pipingMaterial }}
            </div>

            <div class="data-label" v-if="tank.isInstallationTank">
              Pumping System Type:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.pumpingSystemType }}
            </div>

            <div class="data-label" v-if="tank.isInstallationTank">
              Piping Leak Detection:
            </div>
            <div v-if="tank.isInstallationTank">
              {{ tank.pipingLeakDetection }}
            </div>

            <div
              class="data-label"
              v-if="tank.isRemovalTank"
              :ref="`reasonForRemoval${tank.ascaTankNumber}`"
            >
              Reason for Removal:
            </div>
            <div v-if="tank.isRemovalTank">
              {{ tank.removalReasonType }}
            </div>

            <div class="data-label" v-if="tank.isRemovalTank">
              Is piping being removed:
            </div>
            <div v-if="tank.isRemovalTank">
              {{ tank.isPipingBeingRemoved }}
            </div>

            <div
              class="data-label"
              v-if="tank.isRemovalTank && !tank.isPipingBeingRemoved"
              :ref="`reasonForRemovalDesc${tank.ascaTankNumber}`"
            >
              Explaination:
            </div>
            <div v-if="tank.isRemovalTank">
              {{ tank.pipingBeingRemovedExplain }}
            </div>

            <div
              class="data-label"
              v-if="
                showDesc(tank.pipingLeakDetection) && tank.isInstallationTank
              "
            >
              Piping Leak Detection Description:
            </div>
            <div
              v-if="
                showDesc(tank.pipingLeakDetection) && tank.isInstallationTank
              "
            >
              {{ tank.pipingLeakDetectionDescription }}
            </div>
          </div>
        </fieldset>
      </div>
    </fieldset>

    <fieldset>
      <legend><h3>Fee Info</h3></legend>
      <ejs-grid
        v-if="feeDetails"
        :dataSource="feeDetails"
        allowResizing="true"
        allowTextWrap="true"
      >
        <e-columns>
          <e-column headerText="Product" field="feeType" />
          <e-column headerText="Fee" format="C2" field="feeUnitAmount" />
          <e-column headerText="Quantity" field="quantity" />
          <e-column headerText="Total" format="C2" field="totalAmount" />
        </e-columns>
      </ejs-grid>
    </fieldset>

    <fieldset>
      <legend><h3>Documents</h3></legend>
      <fieldset>
        <legend>
          <h5>Uploaded Documents</h5>
        </legend>
        <ejs-grid
          ref="grid"
          :dataSource="documents"
          :commandClick="deleteButtonClick"
          allowResizing="true"
          allowTextWrap="true"
        >
          <e-columns>
            <e-column headerText="Name" field="appDocument.documentName" />
            <e-column
              headerText="Document Type"
              field="appDocument.documentType"
            />
            <e-column
              headerText="Date Uploaded"
              type="date"
              format="dd/MM/yyyy"
              field="appDocument.createDate"
            />
            <e-column headerText="Uploaded By" field="appDocument.createUser" />
            <e-column headerText="Delete Document" :commands="commands" />
          </e-columns>
        </ejs-grid>
      </fieldset>
      <fieldset>
        <legend>
          <h5>Upload Documents here</h5>
        </legend>
        <ejs-grid
          ref="documentUploadGrid"
          :dataSource="documentsUploadInfo"
          :queryCellInfo="customiseCell"
          :allowResizing="true"
          :allowTextWrap="true"
        >
          <e-columns>
            <e-column
              headerText="Document Type"
              :template="documentTypeTemplate"
            />
            <e-column
              headerText="Upload File"
              :template="uploadFileColumnTemplate"
            />
          </e-columns>
        </ejs-grid>
      </fieldset>
    </fieldset>

    <fieldset>
      <legend><h3>Authorization</h3></legend>
      <h3>
        By submitting this form, I verify the information provided to be true and
        correct and have completed the application with all required documents
        uploaded to support this application.
      </h3>
      <div class="grid-container">
        <div ref="applicantNameAuth">
          <ejs-textbox
            float-label-type="Always"
            placeholder="Applicant Name:"
            v-model="permit.printName"
            @input="onChagingApplicantName"
            :maxlength="250"
          />
          <label class="e-error" v-if="applicantNameNotEntered"
            >This field is required</label
          >
        </div>
        <ejs-textbox
          float-label-type="Always"
          placeholder="Applicant Signature:"
          cssClass="italic"
          :readonly="true"
          :value="permit.printName"
        />
        <date-info
          ref="requestDateRef"
          dateType="requestDate"
          placeHolder="Date of Signature:"
        />
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import { CommandColumn } from '@syncfusion/ej2-vue-grids';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { deleteDocument, uploadFile } from '../services/permitting-api';
import dateInfo from './common/date-info.vue';
import { getDisplayDate } from '../../../utils/date-utils';

const documentTypeTemplate = Vue.component('documentTypeTemplate', {
  template: `<div>
                <h3>{{ typeName }} </h3>
                <ul v-for="(desc, index) in data.description" :key="index" style="list-style-type:none;">
                  <li><i>{{ desc }}</i></li>
                </ul>
              </div>`,
  data() {
    return {
      data: {},
    };
  },
  computed: {
    typeName() {
      const { typeName } = this.data;
      return `${
        typeName.toLowerCase() === 'site diagram' ? `${typeName}  *` : typeName
      }`;
    },
  },
});

const uploadFileColumnTemplate = Vue.component('uploadFileColumnTemplate', {
  template: `<div>
              <div>
              <ejs-textbox
              ref='documentNameTextbox'
              placeholder="Enter File Name..."
              @input='onEnteringDocumentName'
              :maxlength="250"
              />
              <div style='color:grey;font-size:12px'><b>Note:</b> Do not use special characters: \\/:*?"<>|</div>
              <div style="padding-top:3%;padding-left:30%">
                <input type="file" 
                @change="onFileSelection" 
                :ref="documentTypeId"
                :id="documentTypeId"
                style="display:none;" />
                <button>
                  <label :for="documentTypeId">
                    Select File
                  </label>
                </button>
                <button 
                  :id='uploadButtonId'
                  :ref='uploadButtonId'
                  :disabled='disableUploadButton'
                  @click="uploadFile">
                  Upload File
                </button>
              </div>
              </div>
            </div>`,
  data() {
    return {
      data: {},
      document: {
        ePermitId: null,
        appDocument: {
          documentType: null,
          appDocument: null,
          documentContent: null,
          documentName: null,
        },
      },
      previousValue: null,
    };
  },
  computed: {
    ...mapGetters({
      permit: 'permit',
    }),
    documentTypeId() {
      return this.data.documentTypeId;
    },
    uploadButtonId() {
      return `upload${this.documentTypeId}`;
    },
    disableUploadButton() {
      const document = this.document.appDocument;
      return !(
        document.documentName?.length > 0
        && document.documentContent?.length > 0
      );
    },
  },

  methods: {
    onEnteringDocumentName(args) {
      // eslint-disable-next-line no-useless-escape
      const format = /[\/:*?"<>|]/;
      if (format.test(args.event.data)) {
        // eslint-disable-next-line no-param-reassign
        args.container.querySelector('input').value = this.previousValue;
      } else {
        // eslint-disable-next-line no-param-reassign, no-multi-assign
        args.container.querySelector('input').value = this.previousValue = args.value;
      }
      this.document.appDocument.documentName = args.container.querySelector('input').value;
    },

    onFileSelection(e) {
      const selectedFile = e.target?.files[0];
      if (selectedFile) {
        const document = this.document.appDocument;
        const fileName = selectedFile.name;
        const fileInfo = fileName.split('.');
        document.fileType = fileInfo[fileInfo.length - 1];
        document.documentType = this.data.typeName;
        document.documentName = fileName.slice(
          0,
          fileName.length - (document.fileType.length + 1),
        );
        this.$refs.documentNameTextbox.$el.value = document.documentName;
        this.document.ePermitId = this.permit.ePermitId;

        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = (ee) => {
          const contents = ee.target.result;
          if (contents) {
            document.documentContent = contents.substring(
              contents.indexOf(',') + 1,
            );
          }
        };
      }
    },

    async uploadFile() {
      const document = this.document.appDocument;
      const fileName = document.documentName;
      const actualFileType = document.fileType;
      let userDefinedType = fileName.split('.');
      const parent = this.$parent.$parent;
      const grandParent = parent.$parent;
      userDefinedType = userDefinedType[userDefinedType.length - 1];
      if (userDefinedType.toLowerCase() !== actualFileType.toLowerCase()) document.documentName = `${fileName}.${actualFileType}`;

      await uploadFile(this.document)
        .then((res) => {
          grandParent.addDocuments(res.data);
          this.$refs.documentNameTextbox.$el.value = null;
          this.$refs[this.documentTypeId].value = '';
          grandParent.validatePermitValues();
          parent.$refs.grid.refresh();
          this.$parent.$parent.addRemoveErrorClassToCells();
        })
        .catch((err) => {
          grandParent.showToastNotification(
            'Error !',
            err.response.data.message,
            'e-toast-danger',
          );
        });
    },
  },
});

let DialogObj;

export default {
  components: { dateInfo },
  props: {
    feeDetails: Array,
    documents: Array,
    documentsUploadInfo: Array,
    forSingleWall: Array,
    forDoubleWall: Array,
  },
  name: 'ReviewSummary',
  provide: {
    grid: [CommandColumn],
  },
  data() {
    return {
      documentTypeTemplate: () => ({
        template: documentTypeTemplate,
      }),
      uploadFileColumnTemplate: () => ({
        template: uploadFileColumnTemplate,
      }),
      documentIdToDelete: null,
      applicantNameNotEntered: false,
      commands: [
        {
          type: 'Delete Document',
          buttonOption: {
            cssClass: 'e-flat deletebtn',
            iconCss: 'e-delete e-icons',
          },
        },
      ],
    };
  },
  watch: {
    printName(printName) {
      const parent = this.$parent;
      parent.disabled = !printName || parent.errorsArray.length > 0;
    },
  },
  computed: {
    ...mapGetters({
      permit: 'permit',
      loggedUser: 'loggedUser',
      municipalities: 'getMunicipalities',
      applicationWorkLists: 'applicationWorkLists',
      staticMessage: 'staticMessage',
    }),
    printName() {
      return this.permit.printName;
    },
    commentsLabel() {
      if ((!this.permit.installerContact.cpcaId && !this.permit.installerContact.tssaId)
       || (this.permit.installerContact.cpcaId && this.permit.installerContact.tssaId)) {
        return 'CPCA/TSSA Comments';
      }
      if (this.permit.installerContact.cpcaId) {
        return 'CPCA Comments';
      }
      if (this.permit.installerContact.tssaId) {
        return 'TSSA Comments';
      }

      return 'Comments';
    },
    facilityType() {
      return this.permit.ePermitSite.facilityType;
    },
    permitApplicant() {
      if (this.permit.isOwnerSameApplicant) return 'Owner';
      if (this.permit.isContractorSameApplicant) return 'Contractor';
      if (this.permit.isEngineerSameApplicant) return 'Engineer';
      return null;
    },
    applicationDate() {
      let date = this.permit.applicationDate;
      if (date) {
        date = new Date(date).toLocaleDateString();
      }
      return date;
    },
    estStartDate() {
      let date = this.permit.estStartDate;
      if (date) {
        date = new Date(date).toLocaleDateString();
      }
      return getDisplayDate(date);
    },
    estEndDate() {
      let date = this.permit.estEndDate;
      if (date) {
        date = new Date(date).toLocaleDateString();
      }
      return getDisplayDate(date);
    },
    permitType() {
      let str = '';
      const { permit } = this;
      if (permit.isInstallation) str += 'Installation,';
      if (permit.isRemoval) str += 'Removal,';
      if (permit.isPipingReplacement) str += 'Piping Replacement,';
      return str.slice(0, -1);
    },
    showFacilityTypeDesc() {
      return this.permit.ePermitSite?.facilityType?.toLowerCase() === 'other';
    },
    supplierRemovalCompanyLabel() {
      return this.permit.isOilRemovalCompany
        ? 'Oil Removal Company Info'
        : 'Fuel Supplier Info';
    },
    permitStatus() {
      const { ePermitSite } = this.permit;
      if (ePermitSite.isWorkNotStarted) {
        return 'Work has not started';
      } if (ePermitSite.isWorkInProgress) {
        return 'Work is in progress';
      } if (ePermitSite.isWorkCompleted) {
        return 'Work is complete';
      }
      return null;
    },
    otherPermitsRequired() {
      let str = '';
      const { permit } = this;
      if (permit.otherPermitBuilding) str += 'Building,';
      if (permit.otherPermitElectrical) str += 'Electrical,';
      if (permit.otherPermitGas) str += 'Gas,';
      if (permit.otherPermitPSDS) str += 'PSDS,';
      if (permit.otherPermitPlumbing) str += 'Plumbing,';
      return str.slice(0, -1);
    },
    municipality() {
      return this.municipalities?.find(
        (x) => x.municipalityID === this.permit.municipalityId,
      )?.name;
    },
  },
  methods: {
    showDesc(val) {
      return val?.toLowerCase().includes('other');
    },
    onChagingApplicantName(e) {
      this.applicantNameNotEntered = e.value === '' || !e.value;
      if (!this.applicantNameNotEntered) this.$refs.applicantNameAuth.classList.remove('e-error');
    },
    addRemoveErrorClassToCells(cellHeadings = null) {
      let engineeringCellHeading = null;
      let siteDiagramCellHeading = null;
      if (cellHeadings) {
        engineeringCellHeading = cellHeadings.engineeringCellHeading;
        siteDiagramCellHeading = cellHeadings.siteDiagramCellHeading;
      } else {
        const gridInstance = this.$refs.documentUploadGrid.ej2Instances;
        // eslint-disable-next-line prefer-destructuring
        engineeringCellHeading = gridInstance.getCellFromIndex(0, 0)
          .childNodes[0].childNodes[0];
        // eslint-disable-next-line prefer-destructuring
        siteDiagramCellHeading = gridInstance.getCellFromIndex(1, 0)
          .childNodes[0].childNodes[0];
      }

      const isEngineeringDrawing = this.documents?.find(
        (x) => x.appDocument.documentType.toLowerCase() === 'engineered drawings',
      );

      const isSiteDiagram = this.documents?.find(
        (x) => x.appDocument.documentType.toLowerCase() === 'site diagram',
      );

      if (!isEngineeringDrawing) {
        this.permit.ePermitSite.eSiteTanks.some((tank) => {
          if (tank.tankType && tank.tankType !== 'Aboveground < 8,000 liters') {
            // eslint-disable-next-line no-unused-expressions
            engineeringCellHeading?.classList.add('e-error-cell');
          }
          return null;
        });
      } else {
        // eslint-disable-next-line no-unused-expressions
        engineeringCellHeading?.classList.remove('e-error-cell');
      }

      if (!isSiteDiagram) {
        // eslint-disable-next-line no-unused-expressions
        siteDiagramCellHeading?.classList.add('e-error-cell');
      } else {
        // eslint-disable-next-line no-unused-expressions
        siteDiagramCellHeading?.classList.remove('e-error-cell');
      }
    },

    customiseCell(e) {
      if (e) {
        const cellHeadings = {};
        if (e.data.typeName === 'Engineered Drawings') {
          // eslint-disable-next-line prefer-destructuring
          cellHeadings.engineeringCellHeading = e.cell.childNodes[0].childNodes[0];
        }
        if (e.data.typeName === 'Site Diagram') {
          // eslint-disable-next-line prefer-destructuring
          cellHeadings.siteDiagramCellHeading = e.cell.childNodes[0].childNodes[0];
        }
        this.addRemoveErrorClassToCells(cellHeadings);
      }
    },
    hideDeleteDialog() {
      DialogObj.hide();
    },
    deleteButtonClick(args) {
      this.documentIdToDelete = args.rowData.appDocument.documentId;
      DialogObj = DialogUtility.confirm({
        title: 'Delete Document',
        content: 'Are you sure you want to delete document?',
        okButton: { text: 'OK', click: this.deleteDocument },
        cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: 'Zoom' },
      });
    },
    async deleteDocument() {
      await deleteDocument(this.documentIdToDelete)
        .then(() => {
          this.$parent.deleteDocument(this.documentIdToDelete);
          this.$refs.grid.refresh();
          this.$parent.validatePermitValues();
          this.hideDeleteDialog();
          this.addRemoveErrorClassToCells();
        })
        .catch(() => {
          this.hideDeleteDialog();
          this.$parent.showToastNotification(
            'Error !',
            'Error while deleting document',
            'e-toast-danger',
          );
        });
    },
    getName(contact) {
      return `${contact.fName ?? ''} ${contact.lName ?? ''}`;
    },
    forASTSingleDoubleTilte(value) {
      if (value === 'Double Wall') return 'Secondary Containment';
      return 'Single Wall';
    },
    forASTSingleDoubleValue(tank) {
      if (tank.atsDoubleWall) return tank.atsDoubleWall;
      if (tank.atsSingleWall) return tank.atsSingleWall;
      return null;
    },
    getVentPiping(tank) {
      let str = '';
      if (tank.ventPipingCombusible) str += 'Combustible,';
      if (tank.ventPipingFlammable) str += 'Flammable,';
      if (tank.ventPipingAboveGrade) str = `${str}Above Grade Collision Protection,`;
      return str.slice(0, -1);
    },
    getPiping(tank) {
      let str = '';
      if (tank.pipingAboveground) str += 'Aboveground,';
      if (tank.pipingBelowground) str += 'Underground,';
      if (tank.pipingNone) str += 'No piping,';
      return str.slice(0, -1);
    },
  },
};
</script>

<style>
.e-error-cell {
  color: red !important;
}
.italic.e-float-input > .e-textbox {
  font-family: "Bradley Hand ITC", sans-serif;
  font-size: 14px;
}
.data-label {
  font-weight: bold;
  font-style: italic;
}
.grid-container-installer-details {
  display: grid;
  grid-gap: 10px;
  padding: 10px;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  padding: 10px;
  column-gap: 5%;
}
.documentUpload-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  padding: 10px;
  column-gap: 5%;
}
</style>
